<c-card *transloco="let t">
  <c-card-body class="px-2" *ngIf="this.account">


      <c-row>
        <c-col class="col-12 col-md-8">
          <h1>{{ t('Use what3words with OK Alone') }}</h1>
          <p>
            {{ t('OK Alone has partnered with what3words to provide worker locations in their 3 word format: ///limit.broom.flip') }}<br/>
          </p>

        </c-col>
        <c-col class="col-12 col-md-4">
          <div class="alert alert-success" role="alert" *ngIf="this.account.w3w">
            {{ t('w3w is activated on your account.') }}
          </div>
          <c-card>
            <c-card-header class="justify-content-center">
              <c-row *ngIf="!this.account.w3w">
                <label>{{ t('Activate what3words') }}</label>
                <button type="button" class="btn btn-success btn-sm text-white" (click)="toggleEnabled(account)">
                  <span>{{ t('Activate') }}</span>
                </button>
              </c-row>
              <c-row *ngIf="this.account.w3w">
                <label>{{ t('Deactivate what3words') }}</label>
                <button type="button" class="btn btn-secondary btn-sm text-white" (click)="toggleEnabled(account)">
                  <span>{{ t('Deactivate') }}</span>
                </button>
              </c-row>
            </c-card-header>
          </c-card>

        </c-col>
      </c-row>
      <c-row>
        <div class="row">
          <div class="col-sm-12">
          <div class="panel panel-default">
              <div class="panel-body">

                  <div class="panel panel-default">
                  <div class="panel-heading"><h3><img src="/assets/images/what3words-icon-small.png" alt="what3words"> {{ t('What is what3words?') }} </h3></div>
                  <div class="panel-body">
                  <div class="row">
                      <div class="col-sm-12 col-md-6">
                      <p>{{ t('When responding to incidents, knowing exactly where they are is key for us to respond quickly. The challenge is that many places don’t have an address, and long, descriptive directions are time-consuming to follow.') }}</p>
                  <p>{{ t('what3words has divided the world into 3 metre squares and given each square a unique combination of three words: a what3words address. ') }}<br/>
                  {{ t('For example ') }}<b>///tower.defeat.land</b>{{ t(' will take you a precise 3 metre square at the top of Parliament Hill, London') }}</p>
                  <p>{{ t('Many companies and emergency services around the world are using what3words to locate people in emergencies, our integration means that any last known location for a worker can easily be translated into a what3words location') }}</p>
                      </div>
                      <div class="col-sm-12 col-md-6 text-center">
                      <img src="/assets/images/what-three-words-location.jpg" alt="what3words Location Example" class="img-thumbnail img-responsive pull-right">
                      </div>
                  </div>




                  </div>
                  </div>



                  <div class="panel panel-default">
                  <div class="panel-heading"><h3><img src="/assets/images/what3words-icon-small.png" alt="what3words">{{ t(' How does what3words work with OK Alone?') }}</h3></div>
                  <div class="panel-body">
                  <p>
                      {{ t("OK Alone shows your workers' last known location on a map and as coordinates. By activating what3words, you will also get the three-word location. This can be used to pinpoint your worker over the phone or SMS with anyone else that also uses the what3words system.") }}</p>
                      <div class="row">
                      <div class="col-sm-12 col-md-6">
                          <h4>{{ t('what3words in the Dashboard') }}</h4>
                          <p>{{ t('On the Dashboard home page where any workers last known location is shown. The monitor can click on the ') }} <b>{{ t('Get Location ') }}</b> {{ t('link to generate a what3words location.') }}</p>
                      <img src="/assets/images/what-3-words-demo-link.png" alt="what3words Dashboard Example" class="img-thumbnail img-responsive">
                      </div>
                      <div class="col-sm-12 col-md-6 text-center">
                      <img src="/assets/images/what-3-words-demo.png" alt="what3words Dashboard Example" class="img-thumbnail img-responsive">
                      </div>
                      </div>

                      <hr/>
                      <div class="row">
                      <div class="col-sm-12 col-md-6">
                          <h4>{{ t('what3words in Alerts') }}</h4>
                          <p>{{ t('Any alerts sent to monitors will also include the what3words location alongside the last known location map and Google link. ') }}</p>
                      </div>
                      <div class="col-sm-12 col-md-6 text-center">
                      <img src="/assets/images/what-3-words-demo-email.png" alt="what3words Email Example" class="img-thumbnail img-responsive">
                      </div>
                      </div>


                  </div>
                  </div>

              </div>
          </div>
          </div>
      </div>
      </c-row>
  </c-card-body>
</c-card>
